import { agroApi } from "shared/api/agroApi";
import { PagedResponse } from "shared/model/api";
import {
  ServiceCategory,
  ServiceCategoryFilter,
} from "features/serviceCategory/model/serviceCategory";

export const serviceCategoryApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getServiceCategoryList: builder.query<
      PagedResponse<ServiceCategory>,
      ServiceCategoryFilter
    >({
      query: (filter) => ({
        url: "/service-category/get-all",
        method: "POST",
        body: { ...(filter ?? {}) },
      }),
      providesTags: [{ type: "ServiceCategory", id: "LIST" }],
    }),

    findAllServiceCategory: builder.query<ServiceCategory[], void>({
      query: () => ({
        url: "/service-category/find-all",
        method: "POST",
      }),
      providesTags: [{ type: "ServiceCategory", id: "LIST" }],
    }),

    createServiceCategory: builder.mutation<{ id: number }, FormData>({
      query: (formData) => ({
        url: "/service-category",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [{ type: "ServiceCategory", id: "LIST" }],
    }),

    updateServiceCategory: builder.mutation<void, FormData>({
      query: (formData) => ({
        url: "/service-category",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: [{ type: "ServiceCategory", id: "LIST" }],
    }),

    deleteServiceCategory: builder.mutation<void, number>({
      query: (id) => ({
        url: `/service-category/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "ServiceCategory", id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetServiceCategoryListQuery,
  useLazyGetServiceCategoryListQuery,
  useFindAllServiceCategoryQuery,
  useCreateServiceCategoryMutation,
  useUpdateServiceCategoryMutation,
  useDeleteServiceCategoryMutation,
} = serviceCategoryApi;
